export const CREATE_CIRCULAR_ROUTE = "create-circular";
export const UPDATE_CIRCULAR_ROUTE = "update-circular";

// School announcement permissions
export const ANNOUNCEMENT_MODULE_PERMISSION = "Module:Announcements";
export const ANNOUNCEMENT_CREATE_PUBLISH_PERMISSION =
  "Announcements:CanCreateAndPublishAnnouncements";
export const ANNOUNCEMENT_CREATE_PUBLISH_PROGRAM_PERMISSION =
  "Announcements:CanCreateAndPublishAnnouncementsToTheirProgram";
export const ANNOUNCEMENT_CREATE_PUBLISH_CLASS_PERMISSION =
  "Announcements:CanCreateAndPublishAnnouncementsClasses";
export const ANNOUNCEMENT_VIEW_ALL_PERMISSION =
  "Announcements:CanViewAllAnnouncements";

// class announcement permissions
export const CLASS_ANNOUNCEMENT_MODULE_PERMISSION = "Module:ClassAnnouncements";
export const CLASS_ANNOUNCEMENT_MANAGE_PERMISSION =
  "ClassAnnouncements:CanManageClassAnnouncements";

// Feature Flags
export const ANNOUNCEMENT_FEATURE_FLAG = "FeatureFlag:AnnouncementV2";
export const ANNOUNCEMENT_REVIEW_FEATURE_FLAG = "Common:AnnouncementReviewFlow";
export const ANNOUNCEMENT_BIN_FEATURE_FLAG = "FeatureFlag:AnnouncementBin";
export const ANNOUNCEMENT_LIVE_SYNC_FEATURE_FLAG =
  "FeatureFlag:AnnouncementLiveDraft";
export const ANNOUNCEMENT_V3_FEATURE_FLAG = "FeatureFlag:AnnouncementV3";
export const DISABLE_SEND_EMAIL_FEATURE_FLAG = "FeatureFlag:DisableSendEmail";
export const ANNOUNCEMENT_24H_FORMAT_FEATURE_FLAG =
  "FeatureFlag:Announcement24hFormat";
export const ANNOUNCEMENT_AI_ASSISTANT = "FeatureFlag:ChatAIAnnouncement";
export const ANNOUNCEMENT_DEFAULT_BANNER_FEATURE_FLAG =
  "FeatureFlag:ShowDefaultBannerOption";
export const CLASS_ANNOUNCEMENT_FEATURE_FLAG = "FeatureFlag:ClassAnnouncement";
export const DUAL_PANEL_MANAGER_V2_FEATURE_FLAG =
  "FeatureFlag:DualPanelManagerV2";
export const COMBINED_CURRICULUM_HOMEPAGE_FEATURE_FLAG =
  "FeatureFlag:CombineCurriculumHomePage";
export const BIG_ORG_OPTIMIZATION_FEATURE_FLAG =
  "FeatureFlag:DualPanelManagerV3";
